module.exports = __webpack_public_path__ + "media/images/about/ac_2-77a1c84e7448dcf998d46f0502039e0b.jpg";